import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { FormArgument } from '@/models/template-setting'

const TEMPLATE_INFO_URL = '/rest/es/crmtemplatemapping/getByUser'
const TEMPLATE_LIST_URL = '/rest/es/crmtemplatemapping/listTemplate'
const SUBMIT_TEMPLATE_URL = '/rest/es/crmtemplatemapping/post'

export default {
  getInfo ({form}, cb) {
    http.get(TEMPLATE_INFO_URL, {params: form}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getList ({form}, cb) {
    http.get(TEMPLATE_LIST_URL, {params: form}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  submit ({form}, cb) {
    console.log(form)
    let postData = convert.toStringify(form, FormArgument)
    http.post(SUBMIT_TEMPLATE_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/template-setting.js